import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthKitProvider } from '@workos-inc/authkit-react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 2026-11-02: devMode — no custom auth domain ($99/mo), so WorkOS keeps the refresh token in local storage */}
    <AuthKitProvider clientId={process.env.REACT_APP_WORKOS_CLIENT_ID} devMode={true}>
      <App />
    </AuthKitProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
